import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import hqApi, { HQ_TOKEN_KEY } from "@/lib/hqApi";

const Ctx = createContext(null);

export function HqAuthProvider({ children }) {
  const [state, setState] = useState({ loading: !!localStorage.getItem(HQ_TOKEN_KEY), user: null, tenant: null });
  const refresh = useCallback(async () => {
    if (!localStorage.getItem(HQ_TOKEN_KEY)) { setState({ loading: false, user: null, tenant: null }); return; }
    try { const { data } = await hqApi.get("/auth/me"); setState({ loading: false, user: data.user, tenant: data.tenant }); }
    catch { localStorage.removeItem(HQ_TOKEN_KEY); setState({ loading: false, user: null, tenant: null }); }
  }, []);
  useEffect(() => { refresh(); const out = () => setState({ loading: false, user: null, tenant: null }); window.addEventListener("hq:logout", out); return () => window.removeEventListener("hq:logout", out); }, [refresh]);
  const login = (data) => { localStorage.setItem(HQ_TOKEN_KEY, data.token); setState({ loading: false, user: data.user, tenant: data.tenant }); };
  const logout = () => { localStorage.removeItem(HQ_TOKEN_KEY); setState({ loading: false, user: null, tenant: null }); };
  return <Ctx.Provider value={{ ...state, login, logout, refresh }}>{children}</Ctx.Provider>;
}

export const useHq = () => useContext(Ctx);

export function useCockpitBody() {
  useEffect(() => { document.body.classList.add("mfg-cockpit"); return () => document.body.classList.remove("mfg-cockpit"); }, []);
}

export function HqFooter({ dark = false }) {
  return (
    <footer className={`text-center text-[11px] py-3 border-t ${dark ? "border-white/10 text-white/50" : "border-black/10 text-neutral-500"}`} data-testid="hq-powered-by">
      Powered by Montana Freight Group software
    </footer>
  );
}
